<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="editOrgNameDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Edit Organization Name</div
  >

  <form
    class="flex w-80 flex-col"
    [formGroup]="editOrgNameForm"
    (ngSubmit)="save()"
  >
    <input
      #orgName
      autocomplete="off"
      spellcheck="false"
      data-cy="editOrgNameDialogOrgNameInput"
      class="form-input border-s3 focus:border-m600 mt-9 rounded"
      [ngClass]="{
        'border-r600':
          editOrgNameForm.controls['orgName'].invalid &&
          editOrgNameForm.controls['orgName'].touched
      }"
      formControlName="orgName"
      placeholder="Name"
    />
    <m-validation
      [control]="editOrgNameForm.controls['orgName']"
    ></m-validation>

    <div class="mt-6">
      <button
        data-cy="editOrgNameDialogSaveButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Save</button
      >

      <button
        data-cy="editOrgNameDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
